import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import styles from './WhatsAppFloat.module.css';

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/918183934567"
      target="_blank"
      rel="noopener noreferrer"
      className={styles.whatsappFloat}
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp className={styles.icon} />
    </a>
  );
};

export default WhatsAppFloat;
